<template>
  <div class="pages">
    <div class="pageContent infoPage">
      <div
        class="steps-background-wrapper"
        :style="
          showCount > 1 ? '' : 'height: 0;padding:0;margin:0;visibility: hidden'
        "
      >
        <img class="steps-background" src="@/assets/img/stepsBg.png" alt="" />
      </div>
      <van-steps
        ref="stepBar"
        :style="
          showCount > 1 ? '' : 'height: 0;padding:0;margin:0;visibility: hidden'
        "
        :active="active"
        class="info-steps-v2"
      >
        <van-step v-if="show1" :step="STEP.BASE_INFO">{{
          $t("steps.person")
        }}</van-step>
        <van-step v-if="show2" :step="STEP.ATTEND">{{
          $t("steps.active")
        }}</van-step>
        <van-step v-if="show3" :step="STEP.ARRIVE_LEAVE">{{
          $t("steps.trip")
        }}</van-step>
      </van-steps>
      <div
        class="step-content"
        :style="showCount <= 1 ? 'margin-top: 0; border-radius: 0' : ''"
      >
        <!-- <div> -->
        <person-info
          v-show="activeStep === STEP.BASE_INFO"
          :ref="'step' + STEP.BASE_INFO"
          :formDisabled="formDisabled1"
        />
        <activity-inte
          v-show="activeStep === STEP.ATTEND"
          :ref="'step' + STEP.ATTEND"
          :formDisabled="formDisabled2"
        />
        <trip-info
          v-show="activeStep === STEP.ARRIVE_LEAVE"
          :ref="'step' + STEP.ARRIVE_LEAVE"
          :formDisabled="formDisabled3"
        />
        <!-- </div> -->
        <div class="information-box button-group" v-if="btnShow">
        <!-- activeStep !== lastStep当前不是最后一页（显示下一页） -->
        <!-- !formDisabled1 || !formDisabled2 || !formDisabled3 3个中有一个能填，就可以显示。（显示提交） -->
          <van-button
            :disabled="submitLoading"
            :class="{ 'only-one': !(active > 0) }"
            type="info"
            @click="goNext"
            v-if="activeStep !== lastStep || (!formDisabled1 || !formDisabled2 || !formDisabled3)"
            >{{ nextButton }}</van-button
          >
          <!-- 前一个不显示的话，则加only-one的class -->
          <van-button plain type="info" v-show="active > 0" @click="goPrev" :class="{ 'only-one': !(activeStep !== lastStep || (!formDisabled1 || !formDisabled2 || !formDisabled3)) }">{{
            $t("form.label.previous")
          }}</van-button>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="guestInfo"
      :title="$t('noticeDia.title')"
      theme="round-button"
      :confirm-button-text="$t('read')"
      class="notice-dialog"
    >
      <div class="notice-dialog-body">
        <div v-html="$t1(instruction, 'instruction')"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getPersonInfo,
  updateBaseInfo,
  updateAttend,
  updateArrival,
  updateLeave,
  updateAccommodate,
  confirmInfo,
} from "@/api/guest";
import { getGusetInstruction, getConferenceInfo } from "@/api/conference";
import PersonInfo from "./guestInfo/personInfo";
import TripInfo from "./guestInfo/tripInfo";
import ActivityInte from "./guestInfo/activityInte";
import { mapGetters } from "vuex";
import MonitorKeyboard from "@/utils/monitorKeyboard.js";

const STEP = {
  BASE_INFO: "baseInfo",
  ATTEND: "attend",
  ARRIVE_LEAVE: "arriveLeave",
};

export default {
  name: "guestInfo",
  components: { PersonInfo, TripInfo, ActivityInte },
  data() {
    return {
      STEP,
      active: 0,
      guestInfo: false,
      language: "zh",
      form: {},
      instruction: {},
      monitorKeyboard: null,
      inputVal: "",
      btnShow: true,
      activeStep: "",
      submitLoading: false,
      updateCount: 0,
      errorCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      "needUpdateInfo",
      "status",
      "location",
      "joinState",
      "firstStep",
      "lastStep",
      "show1",
      "show2",
      "show3",
      "showCount",
      "edit1",
      "edit2",
      "edit3",
      "editCount",
    ]),
    nextButton() {
      return this.activeStep === this.lastStep
        ? this.needUpdateInfo
          ? this.$t("form.label.submitAndConfirm")
          : this.$t("form.label.submit")
        : this.$t("form.label.next");
    },
    formDisabled1() {
      return this.joinState === 99 || this.joinState === '99' || !this.edit1 || !this.needUpdateInfo
    },
    formDisabled2() {
      return this.joinState === 99 || this.joinState === '99' || !this.edit2
    },
    formDisabled3() {
      return this.joinState === 99 || this.joinState === '99' || !this.edit3
    }
  },
  mounted() {
    this.activeStep = this.firstStep;
    if (this.needUpdateInfo) {
      this.guestInfo = true;
    }
    console.log(this.$i18n.locale);
    this.language = this.$i18n.locale;
    this.getPersonInfo();
    this.getGusetInstruction();
    // this.getKeyboardState();
    this.checkActiveTab();
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then((res) => {
        this.form = res.data;
        this.$nextTick(() => {
          if (this.show1) {
            this.$refs["step" + STEP.BASE_INFO].initForm(this.form);
          }
          if (this.show2) {
            this.$refs["step" + STEP.ATTEND].initForm(this.form);
          }
          if (this.show3) {
            this.$refs["step" + STEP.ARRIVE_LEAVE].initForm(this.form);
          }
        });
      });
    },
    getGusetInstruction() {
      getGusetInstruction({
        conferenceId: this.$route.params.conferenceId,
      }).then((res) => {
        this.instruction = res.data;
      });
    },
    checkActiveTab() {
      console.log(this.$route.query.step);
      this.$nextTick(() => {
        switch (this.$route.query.step) {
          case STEP.BASE_INFO: {
            if (!this.show1) {
              return;
            }
            this.active = 0;
            this.activeStep = STEP.BASE_INFO;
            break;
          }
          case STEP.ATTEND: {
            if (!this.show2) {
              return;
            }
            if (this.show1) {
              this.active = 1;
            } else {
              this.active = 0;
            }
            this.activeStep = STEP.ATTEND;
            break;
          }
          case STEP.ARRIVE_LEAVE: {
            if (!this.show3) {
              return;
            }
            this.active = this.showCount - 1;
            this.activeStep = STEP.ARRIVE_LEAVE;
            break;
          }
        }
      });
    },
    goNext() {
      const stepBarRef = this.$refs.stepBar;
      const haveNextStep = this.active < stepBarRef.children.length - 1;
      const activeStepName = stepBarRef.children[this.active].$attrs.step;
      const nextStepName = haveNextStep
        ? stepBarRef.children[this.active + 1].$attrs.step
        : null;
      const activeStepRef = this.$refs["step" + activeStepName];
      const nextStepRef = haveNextStep
        ? this.$refs["step" + nextStepName]
        : null;
      const checkNext = () => {
        if (haveNextStep) {
          nextStepRef.initForm(this.form);
          this.active++;
          this.activeStep = nextStepName;
          this.$scrollTop();
        } else {
          if (this.submitLoading) {
            return;
          }
          this.submitLoading = true;
          getConferenceInfo({
            conferenceId: this.$route.params.conferenceId,
          }).then((res) => {
            // if (this.needUpdateInfo) {
            this.$dialog
              .confirm({
                title: this.$t("confirmDia.title"),
                message: this.$t("confirmDia.message"),
                confirmButtonText: this.$t("confirmDia.confirm"),
                cancelButtonText: this.$t("confirmDia.cancel"),
                className: 'confirm-dialog'
              })
              .then(() => {
                this.submitInfo(res);
              })
              .catch(() => {
                this.submitLoading = false;
              });
            // } else {
            //   this.submitInfo(res)
            // }
          });
        }
      };
      if (
        (activeStepName === STEP.BASE_INFO && !this.formDisabled1) ||
        (activeStepName === STEP.ATTEND && !this.formDisabled2) ||
        (activeStepName === STEP.ARRIVE_LEAVE && !this.formDisabled3)
      ) {
        activeStepRef.validate().then(() => {
          this.form = Object.assign({}, this.form, activeStepRef.form);
          checkNext();
        });
      } else {
        checkNext();
      }
    },
    goPrev() {
      if (this.active > 0) {
        const stepBarRef = this.$refs.stepBar;
        const activeStepName = stepBarRef.children[this.active].$attrs.step;
        const prevStepName = stepBarRef.children[--this.active].$attrs.step;
        const activeStepRef = this.$refs["step" + activeStepName];
        const prevStepRef = this.$refs["step" + prevStepName];
        this.form = Object.assign({}, this.form, activeStepRef.form);
        prevStepRef.initForm(this.form);
        this.activeStep = prevStepName;
        this.$scrollTop();
      }
    },
    submitInfo(res) {
      this.updateCount = 0;
      this.errorCount = 0;
      let realEditCount = 0;
      if (!this.formDisabled1) {
        realEditCount++;
        if (
          this.checkTimeBetween(
            res.data.baseInfoStartTime,
            res.data.baseInfoEndTime
          )
        ) {
          const data = JSON.parse(
            JSON.stringify(this.$refs["step" + STEP.BASE_INFO].form)
          );
          if (data.needInvitationLetter === "0") {
            data.needInvitationLetter = 0;
          } else if (data.needInvitationLetter === "1") {
            data.needInvitationLetter = 1;
          }
          updateBaseInfo(data).then(
            (res) => {
              if (res.success) {
                if (++this.updateCount >= realEditCount) {
                  this.finish();
                } else if (
                  this.errorCount + this.updateCount >=
                  realEditCount
                ) {
                  this.finishError();
                }
              } else {
                if (++this.errorCount + this.updateCount >= realEditCount) {
                  this.finishError();
                }
              }
            },
            (err) => {
              if (++this.errorCount + this.updateCount >= realEditCount) {
                this.finishError();
              }
            }
          );
        } else {
          this.$notify(
            this.$t3(
              "不在基本信息收集时间内",
              "Not within the collection time of basic information"
            )
          );
          if (++this.errorCount + this.updateCount >= realEditCount) {
            this.finishError();
          }
        }
      }
      if (!this.formDisabled2) {
        realEditCount++;
        if (
          this.checkTimeBetween(
            res.data.attendStartTime,
            res.data.attendEndTime
          )
        ) {
          updateAttend(this.$refs["step" + STEP.ATTEND].form).then(
            (res) => {
              if (res.success) {
                if (++this.updateCount >= realEditCount) {
                  this.finish();
                } else if (
                  this.errorCount + this.updateCount >=
                  realEditCount
                ) {
                  this.finishError();
                }
              } else {
                if (++this.errorCount + this.updateCount >= realEditCount) {
                  this.finishError();
                }
              }
            },
            (err) => {
              if (++this.errorCount + this.updateCount >= realEditCount) {
                this.finishError();
              }
            }
          );
        } else {
          this.$notify(
            this.$t3(
              "不在意向参会信息收集时间内",
              "Not within the collection time of intended attendance information"
            )
          );
          if (++this.errorCount + this.updateCount >= realEditCount) {
            this.finishError();
          }
        }
      }
      if (!this.formDisabled3) {
        realEditCount += 3;
        if (
          this.checkTimeBetween(
            res.data.arriveLeaveStartTime,
            res.data.arriveLeaveEndTime
          )
        ) {
          const form = this.$refs["step" + STEP.ARRIVE_LEAVE].form;
          const arrivalData = {
            id: this.form.arrivalId,
            conferenceGuestId: this.form.id,
          };
          const leaveData = {
            id: this.form.leaveId,
            conferenceGuestId: this.form.id,
          };
          for (const key in form) {
            arrivalData[key.replace(/A$/, "")] = form[key];
            leaveData[key.replace(/L$/, "")] = form[key];
          }
          const accommodationData = {
            accommodationMode: form.accommodationMode,
            id: this.form.accommodationId,
            conferenceGuestId: this.form.id,
          };
          updateArrival(arrivalData).then(
            (res) => {
              if (res.success) {
                if (++this.updateCount >= realEditCount) {
                  this.finish();
                } else if (
                  this.errorCount + this.updateCount >=
                  realEditCount
                ) {
                  this.finishError();
                }
              } else {
                if (++this.errorCount + this.updateCount >= realEditCount) {
                  this.finishError();
                }
              }
            },
            (err) => {
              if (++this.errorCount + this.updateCount >= realEditCount) {
                this.finishError();
              }
            }
          );
          updateLeave(leaveData).then(
            (res) => {
              if (res.success) {
                if (++this.updateCount >= realEditCount) {
                  this.finish();
                } else if (
                  this.errorCount + this.updateCount >=
                  realEditCount
                ) {
                  this.finishError();
                }
              } else {
                if (++this.errorCount + this.updateCount >= realEditCount) {
                  this.finishError();
                }
              }
            },
            (err) => {
              if (++this.errorCount + this.updateCount >= realEditCount) {
                this.finishError();
              }
            }
          );
          updateAccommodate(accommodationData).then(
            (res) => {
              if (res.success) {
                if (++this.updateCount >= realEditCount) {
                  this.finish();
                } else if (
                  this.errorCount + this.updateCount >=
                  realEditCount
                ) {
                  this.finishError();
                }
              } else {
                if (++this.errorCount + this.updateCount >= realEditCount) {
                  this.finishError();
                }
              }
            },
            (err) => {
              if (++this.errorCount + this.updateCount >= realEditCount) {
                this.finishError();
              }
            }
          );
        } else {
          this.$notify(
            this.$t3(
              "不在意向抵离信息收集时间内",
              "Not within the collection time of intended traffic information"
            )
          );
          if (++this.errorCount + this.updateCount + 2 >= realEditCount) {
            this.finishError();
          }
        }
      }
      if (this.editCount === 0) {
        this.$notify(
          this.$t3(
            "不在修改信息时间内",
            "Not in the time of information modification"
          )
        );
        this.submitLoading = false;
      }
    },
    finish() {
      if (this.needUpdateInfo) {
        confirmInfo().then((res) => {
          if (res.success) {
            this.$store.commit("user/SET_NEED_UPDATE_INFO", false);
            // 跳转页面
            this.$router.push("guestConfirm");
          }
        });
      } else {
        // 跳转页面
        this.$router.push("guestConfirm");
      }
    },
    finishError() {
      this.submitLoading = false;
    },
    // 监听软键盘是否弹出
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // alert('键盘弹出')
        this.btnShow = false;
      });

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        // alert('键盘收起')
        this.btnShow = true;
      });
    },
    beforeDestroy() {
      this.monitorKeyboard.onEnd();
    },
    checkTimeBetween(start, end) {
      if (!start || !end) {
        return false;
      }
      const now = new Date();
      const startDate = new Date(start.replace(/-/g, "/"));
      const endDate = new Date(end.replace(/-/g, "/"));
      if (now >= startDate && now <= endDate) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.blue-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: contain;
}

.person-steps {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  margin: 30px 0 0;
  padding: 0 5px;

  .line {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 293px;
    height: 1px;
    background: rgba(0, 0, 0, 1);
    z-index: -1;
  }

  .person-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 56px;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 20px;

    .circle {
      width: 12px;
      height: 12px;
      border: 2px solid rgba(0, 0, 0, 0.4);
      border-radius: 50%;
    }
  }
}

.information {
  margin: 0 0 0 -15px;
  width: calc(100% + 30px);
  background: #fff;
  border-radius: 10px 10px 0 0;

  .info-title {
    position: relative;
    width: 375px;
    height: 60px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
    }
  }
}
</style>